



















































































































































































































































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  IContractProductProvider,
  IContractProductProviderMethods
} from "@/models/providers/contractProduct";
import { PriceType } from "@/data/enums/contractProducts";
import Context from "@/mixins/context";

@Component({
  components: {
    "cprod-status-reason-tooltip": () =>
      import(
        "@/components/app/global/contractProducts/cProdStatusReasonTooltip.vue"
      ),
    "cprod-modify-link": () =>
      import("@/components/app/global/contractProducts/cProdModifyLink.vue")
  }
})
export default class CProdSummaryRow extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: IContractProductProviderMethods;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get cProd() {
    return this.cProdData.contractProduct;
  }

  public get statusClass() {
    return this.cProdData?.status?.type?.replace(/^is-/, "has-text-");
  }

  // Methods

  public isConvertedPrice(type: PriceType | null) {
    return type === PriceType.CONVERTED;
  }

  public isManualPrice(type: PriceType | null) {
    return type === PriceType.MANUAL;
  }
}
